import './Footer.scss'

export default class Footer {
  /**
   * Create footer logic
   * 
   * @param {Element} root
   */
  constructor (root) {
    this.root = root
  }

  init () {
    return this
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js